import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  CustomButton,
  CustomButtonLight,
} from "../UI/CustomButtons";
import styles from "../../_css/SessionCategoryManagement.module.css";
import { useDispatch } from "react-redux";
import { openPopup } from "../../_store/reducers/trainAIPopupReducer";

const SuccessPopup = ({ show, onHide, categoryName = "Category Name" }) => {
  const dispatch = useDispatch();

  const handleHidePopup = (e) => {
    e.preventDefault();
    onHide();
  };

  const handleAddSession = (e) => {
    e.preventDefault();
    dispatch(openPopup());
    onHide();
  };

  return (
    <Modal centered size="sm" show={show} onHide={onHide}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title>Category Created!</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.iconSection}>
          <div className={styles.iconCircle}>
            <i>
              <img
                width={60}
                src={`${process.env.REACT_APP_PROJECT_URL}/img/green-tick.png`}
                alt="success"
              />
            </i>
          </div>
          <div className={styles.title}>Category Created!</div>
          <div className={styles.message}>
            <p>"Would you like to add a session under"</p>
            <p>'{categoryName}'</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CustomButtonLight
          onClick={(e) => handleHidePopup(e)}
          text="Maybe Later"
          width="48%"
        />
        <CustomButton
          onClick={(e) => handleAddSession(e)}
          text="Add Session"
          width="48%"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessPopup;
